import type { EventFilter, TelemetryEvent } from '@ringba/core/telemetry';

// The SDK builds a report's message as `${report.type}: ${body.message}`.
const INTERVENTION_PREFIX = 'intervention: ';

/**
 * Drops browser intervention reports.
 * CSP violation reports, the SDK's only other report type, are kept.
 */
export function dropInterventionReports<T extends TelemetryEvent>(): EventFilter<T> {
  return (event) => {
    if (event.type !== 'error') return true;

    const isIntervention = event.error?.source === 'report' && !!event.error.message?.startsWith(INTERVENTION_PREFIX);
    return !isIntervention;
  };
}
